import { render, staticRenderFns } from "./total-amount-with-installment.vue?vue&type=template&id=d070b628"
import script from "./total-amount-with-installment.vue?vue&type=script&lang=js"
export * from "./total-amount-with-installment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports